import { render, staticRenderFns } from "./Umbler.vue?vue&type=template&id=4508d63c&"
import script from "./Umbler.vue?vue&type=script&lang=js&"
export * from "./Umbler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports